import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import { Badge, Button, Checkbox, Input, Typography } from '@material-tailwind/react'
import { SubmitHandler, useController, useForm } from 'react-hook-form'
import ElectroConnection from './ElectroConnection'
import GasConnection from './GasConnection'
import { useState } from 'react'
import ModalAddition from './ModalAddition'
import { NavLink, useNavigate } from 'react-router-dom'
import ModalAddFiles from './ModalAddFiles'
import { isIterableArray } from '../../../utils/utils'
import axios from 'axios'
import { baseApi } from '../../../ConfigApi'
import { errorToast, successToast } from '../../toasts/toasts'

import InputMask from 'react-input-mask';
import { EDRPOU_MASK, PHONE_MASK, PHONE_MASK_CHAR } from '../../../utils/variables'
import { AUTH_BG_BODY } from '../../../_configCompanySetup/configAuthPage'

type FormType = {
  legal: boolean,
  name: string,
  edrpou: string,
  contact_type_1: boolean,
  contact_type_2: boolean,
  contact_type_3: boolean,
  phone: string,
  email: string,
  service_1: boolean,
  service_2: boolean,
  group_1: boolean,
  group_2: boolean,
  group_3: boolean,
  group_4: boolean,
  class_1: boolean,
  class_2: boolean,
  class_3: boolean,
  gas_consumption_1: boolean,
  gas_consumption_2: boolean,
  gas_consumption_3: boolean,
  gas_consumption_4: boolean,
  addition_service_1: boolean,
  addition_service_2: boolean,
  addition_service_3: boolean,
  addition_service_4: boolean,
}

const regEmailInput = /^[A-Z0-9._%+-]/i

const PageNewConnection = () => {

  const { t } = useTranslation()

  const navigate = useNavigate()

  const {
    setValue,
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm<FormType>({
    defaultValues: {
      contact_type_1: true
    },
  })

  const [errorsValidService, setErrorsValidService] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const [filesListForSend, setFilesListForSend] = useState<any[]>([]);
  const [isModalFile, setIsModalFile] = useState(false);
  const [isModalAdd, setIsModalAdd] = useState(false)

  const openModalAdd = () => {
    setIsModalAdd(true)
  }
  const closeModalAdd = () => {
    setIsModalAdd(false)
  }
  const openModalFile = () => {
    setIsModalFile(true)
  }
  const closeModalFile = () => {
    setIsModalFile(false)
  }

  const onSubmit: SubmitHandler<FormType> = (data) => {
    if (data.service_1 || data.service_2) {
      setIsLoadingSave(true)
      const formSend = {
        "type": 1,
        "contract_id": 0,
        ...data,
        files: filesListForSend,
        legal: data.legal ? 1 : 0,
        contact_type_1: data.contact_type_1 ? 1 : 0,
        contact_type_2: data.contact_type_2 ? 1 : 0,
        contact_type_3: data.contact_type_3 ? 1 : 0,
        service_1: data.service_1 ? 1 : 0,
        service_2: data.service_2 ? 1 : 0,
        group_1: data.group_1 ? 1 : 0,
        group_2: data.group_2 ? 1 : 0,
        group_3: data.group_3 ? 1 : 0,
        group_4: data.group_4 ? 1 : 0,
        class_1: data.class_1 ? 1 : 0,
        class_2: data.class_2 ? 1 : 0,
        class_3: data.class_3 ? 1 : 0,
        gas_consumption_1: data.gas_consumption_1 ? 1 : 0,
        gas_consumption_2: data.gas_consumption_2 ? 1 : 0,
        gas_consumption_3: data.gas_consumption_3 ? 1 : 0,
        gas_consumption_4: data.gas_consumption_4 ? 1 : 0,
        addition_service_1: data.addition_service_1 ? 1 : 0,
        addition_service_2: data.addition_service_2 ? 1 : 0,
        addition_service_3: data.addition_service_3 ? 1 : 0,
        addition_service_4: data.addition_service_4 ? 1 : 0,
      }
      axios.post(`${baseApi}/api/profile-requestconnect-create`, formSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response: any) => {
          if (response.data.res === 'Error') {
            errorToast({
              title: t('new_connection.new_connection_title'),
              text: t('new_connection.error_on_request')
            })
          }
          else {
            successToast({
              title: t('new_connection.new_connection_title'),
              text: t('new_connection.success_on_request')
            })
            navigate("/auth")
          }
        })
        .catch(error => {
          console.error(error);
          errorToast({
            title: t('new_connection.new_connection_title'),
            text: t('new_connection.error_on_request')
          })
        })
        .finally(() => {
          setIsLoadingSave(false)
        })
    }
    else {
      setErrorsValidService(true)
    }
  }


  const emailField = useController({
    name: 'email',
    control,
    defaultValue: ''
  });

  return (

    <div>
      <Helmet>
        <title>{t('new_connection.new_connection_title')}</title>
      </Helmet>
      <ModalAddition
        open={isModalAdd}
        handleClose={closeModalAdd}
        register={register}
      />
      <ModalAddFiles
        open={isModalFile}
        handleClose={closeModalFile}
        setFilesListForSend={setFilesListForSend}
      />
      <div className='fixed t-0 r-0 b-0 l-0  min-h-[100vh] w-screen'
        style={{
          backgroundImage: `url(${AUTH_BG_BODY})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          zIndex: -1
        }}
      />
      <div className='pb-[32px] min-h-[100vh] des:w-screen flex flex-wrap des:flex-nowrap items-center' >
        <div className='pt-[80px] pb-[48px] tab:pt-[64px] lap:pt-[72px] lap:pb-[72px] px-[16px] tab:px-[32px] lap:px-[48px] des:p-[96px] flex flex-col w-full des:grow-[1] des:w-[25%]  justify-center overflow-hidden text-balance'>
          <Typography variant='lead' className='leading-[1.1] text-[28px] des:text-[40px] text-gray-800 lap:mb-[48px] text-center des:text-left' >
            {t('new_connection.new_connection_title_1')}
            <br />
            <span className='block font-bold'>{t('new_connection.new_connection_title_2')}</span>
          </Typography>
        </div>
        <div className='px-[16px] tab:px-[32px] lap:px-[48px] w-full des:grow-[3] des:w-[75%]'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col lap:flex-row gap-[24px]">
              <div className='flex grow w-full flex-col'>
                <Typography variant='lead' className='text-gray-800 text-[18px] font-bold mb-[24px]' >
                  {t('new_connection.step_1')}
                </Typography>
                <div className='h-full bg-white rounded-[16px] lap:rounded-[24px] p-[24px] tab:p-[32px] lap:p-[48px] flex flex-col gap-[24px] des:gap-[32px]'>

                  {/* name */}
                  <div className='flex flex-col gap-[12px] lap:gap-[16px]'>
                    <label htmlFor='name' className='text-[18px] lap:text-[24px] text-gray-800'>
                      {t('new_connection.name')} <span className='text-red-500'>*</span>
                    </label>
                    <input
                      placeholder={t('new_connection.name_placeholder')}
                      id='name'
                      {...register(`name`, {
                        required: true
                      })}
                      type='text'
                      className={`bg-white border-2 border-gray-200 rounded w-full h-[48px] px-[16px] text-gray-800 text-[14px] des:text-[18px]
                      hover:bg-gray-50 hover:border-gray-300 
                      focus:border-gray-200 focus-visible:!border-gray-200 transition-all
                    `}
                    />
                    <Typography variant='lead' className={`leading-1 mt-[-12px] text-red-500 text-[12px] des:text-[14px] transition-all ${errors.name ? 'opacity-1' : 'opacity-0'}`} >
                      {t('new_connection.required_input_name')}
                    </Typography>
                  </div>

                  {/* edrpou */}
                  <div className='flex flex-col gap-[12px] lap:gap-[16px]'>
                    <label htmlFor='edrpou' className='text-[18px] lap:text-[24px] text-gray-800'>
                      {t('new_connection.edrpou')}
                    </label>
                    {/* <input
                      placeholder={t('new_connection.edrpou_placeholder')}
                      id='edrpou'
                      {...register(`edrpou`)}
                      type='number'
                      className={`bg-white border-2 border-gray-200 rounded w-full h-[48px] px-[16px] text-gray-800 text-[14px] des:text-[18px]
                      hover:bg-gray-50 hover:border-gray-300 
                      focus:border-gray-100 focus-visible:!border-gray-200 transition-all
                    `}
                    /> */}
                    <InputMask
                      placeholder={t('new_connection.edrpou_placeholder')}
                      id='edrpou'
                      {...register(`edrpou`)}
                      className={` bg-white border-2 border-gray-200 rounded w-full h-[48px] px-[16px] text-gray-800 text-[14px] des:text-[18px]
                        hover:bg-gray-50 hover:border-gray-300 
                        focus:border-gray-100 focus-visible:!border-gray-200 transition-all
                      `}
                      mask={EDRPOU_MASK}
                      maskChar=''
                      alwaysShowMask={false}
                    />
                    <Typography variant='lead' className={`text-[12px] des:text-[14px] font-normal`} >
                      {t('new_connection.edrpou_help_title')}
                    </Typography>
                  </div>

                  {/* connect type */}
                  <div className="grid mob:grid-cols-2 mob:gap-[24px]">
                    <Typography variant='lead' className='text-gray-800 text-[16px] des:text-[18px] text-[18px] font-normal mb-[12px] mob:mb-[24px]' >
                      {t('new_connection.contact_type')}
                    </Typography>
                    <div className='flex flex-col gap-[8px]'>
                      <Checkbox
                        {...register(`contact_type_1`)}
                        className='rounded-full checked:bg-white border-2'
                        icon={<span className='block w-[10px] h-[10px] bg-black rounded-full ' />}
                        label={t('new_connection.contact_type_1')}
                        labelProps={{
                          className: 'text-[14px] des:text-[18px]'
                        }}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setValue('contact_type_2', false)
                            setValue('contact_type_3', false)
                          }
                        }}
                      />
                      <Checkbox
                        {...register(`contact_type_2`)}
                        className='rounded-full checked:bg-white border-2'
                        icon={<span className='block w-[10px] h-[10px] bg-black rounded-full ' />}
                        label={t('new_connection.contact_type_2')}
                        labelProps={{
                          className: 'text-[14px] des:text-[18px]'
                        }}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setValue('contact_type_1', false)
                            setValue('contact_type_3', false)
                          }
                        }}
                      />
                      <Checkbox
                        {...register(`contact_type_3`)}
                        className='rounded-full checked:bg-white border-2'
                        icon={<span className='block w-[10px] h-[10px] bg-black rounded-full ' />}
                        label={t('new_connection.contact_type_3')}
                        labelProps={{
                          className: 'text-[14px] des:text-[18px]'
                        }}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setValue('contact_type_1', false)
                            setValue('contact_type_2', false)
                          }
                        }}
                      />
                    </div>
                  </div>


                  {/* PHONE */}
                  <div className='flex flex-col gap-[12px] lap:gap-[16px]'>
                    <label htmlFor='phone' className='text-[18px] lap:text-[24px] text-gray-800'>
                      {t('new_connection.phone')} <span className='text-red-500'>*</span>
                    </label>
                    <InputMask
                      placeholder={t('new_connection.phone_placeholder')}
                      id='phone'
                      {...register(`phone`, {
                        required: t('new_connection.required_input_phone'),
                        minLength: 18
                      })}
                      className={`bg-white border-2 border-gray-200 rounded w-full h-[48px] px-[16px] text-gray-800 text-[14px] des:text-[18px]
                        hover:bg-gray-50 hover:border-gray-300 
                        focus:border-gray-200 focus-visible:!border-gray-200 transition-all
                      `}

                      mask={PHONE_MASK}
                      maskChar={PHONE_MASK_CHAR}
                      alwaysShowMask={false}
                    />
                    <Typography variant='lead' className={`leading-1 mt-[-12px] text-red-500 text-[12px] des:text-[14px] transition-all ${errors.phone ? 'opacity-1' : 'opacity-0'}`} >
                      {errors?.phone?.type === "required" && t('new_connection.required_input_phone')}
                      {errors?.phone?.type === "minLength" && t('new_connection.required_length_input_phone')}
                    </Typography>
                  </div>


                  {/* email */}
                  <div className='flex flex-col gap-[12px] lap:gap-[16px]'>
                    <label htmlFor='email' className='text-[18px] lap:text-[24px] text-gray-800'>
                      {t('new_connection.email')}
                    </label>
                    <input
                      placeholder={t('new_connection.email_placeholder')}
                      id='email'
                      {...register('email', {
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "invalid email address"
                        }
                      })}
                      value={emailField.field.value}
                      onChange={(e) => emailField.field.onChange(() => {
                        if (regEmailInput.test(e.target.value)) return e.target.value
                        else return ''
                      })}
                      className={`bg-white border-2 border-gray-200 rounded w-full h-[48px] px-[16px] text-gray-800 text-[14px] des:text-[18px]
                              hover:bg-gray-50 hover:border-gray-300 
                              focus:border-gray-200 focus-visible:!border-gray-200 transition-all
                            `}
                    />
                    <Typography variant='lead' className={`leading-1 mt-[-12px] text-red-500 text-[12px] des:text-[14px] transition-all ${errors.email ? 'opacity-1' : 'opacity-0'}`} >
                      {errors?.email?.type === "pattern" && t('invalid_email_address')}
                    </Typography>
                  </div>


                </div>
              </div>
              <div className='flex grow w-full flex-col'>
                <Typography variant='lead' className='text-gray-800 text-[18px] font-bold mb-[24px]' >
                  {t('new_connection.step_2')}
                </Typography>
                <div className='h-full bg-white rounded-[16px] lap:rounded-[24px] p-[24px] tab:p-[32px] lap:p-[48px] flex flex-col gap-[24px] lap:gap-[32px]'>
                  <Typography variant='lead' className='text-[18px] lap:text-[24px] text-gray-800'>
                    {t('new_connection.step_2_subtitle')} <span className='text-red-500'>*</span>
                  </Typography>

                  <div className='grid mob:grid-cols-2 gap-[24px] mob:gap-0'>
                    <ElectroConnection control={control} register={register} setValue={setValue} setErrorsValidService={setErrorsValidService} />
                    <GasConnection control={control} register={register} setValue={setValue} setErrorsValidService={setErrorsValidService} />
                  </div>
                  {
                    errorsValidService &&
                    <Typography variant='lead' className={`leading-1  text-red-500 text-[12px] des:text-[14px] transition-all ${errorsValidService ? 'opacity-1' : 'opacity-0'}`} >
                      {t('new_connection.no_selected_service')}
                    </Typography>
                  }

                  <div className='mt-auto flex flex-wrap items-center justify-end mob:justify-start gap-[8px]'>
                    <Typography variant='lead' className='text-[18px] text-gray-800 font-normal'>
                      {t('new_connection.addition_title')}
                    </Typography>
                    <Button color='white' className='px-[16px] py-[4px] rounded-[6px] bg-gray-50' onClick={openModalAdd}>
                      {t('new_connection.addition_btn')}
                    </Button>
                    {
                      isIterableArray(filesListForSend)
                        ?
                        <Badge content={filesListForSend.length}>
                          <Button color='white' className='px-[16px] py-[4px] rounded-[6px] bg-gray-50 text-[14px] tab:text-[16px]' onClick={openModalFile}>
                            {t('new_connection.addition_upload')}
                          </Button>
                        </Badge>
                        :
                        <Button color='white' className='px-[16px] py-[4px] rounded-[6px] bg-gray-50 text-[14px] tab:text-[16px]' onClick={openModalFile}>
                          {t('new_connection.addition_upload')}
                        </Button>
                    }

                  </div>

                </div>
              </div>
            </div>
            <div className="flex flex-col lap:flex-row items-center gap-[24px] mt-[24px] tab:mt-[48px] des:mt-[96px] ">
              <div className='flex grow w-full flex-col'>
                <Typography variant='lead' className={`leading-1 mt-[-12px] text-red-500 text-[12px] des:text-[14px] transition-all ${errors.legal ? 'opacity-1' : 'opacity-0'}`} >
                  {t('new_connection.required_input_legal')}
                </Typography>
                <Checkbox

                  {...register(`legal`, {
                    required: t('new_connection.required_input_name')
                  })}
                  label={
                    <div className='text-[14px] lap:text-[16px]'>
                      {t('new_connection.confirm_text')} <NavLink to={'#'} className={'underline font-bold'}>{t('new_connection.confirm_link')}</NavLink> <span className='text-red-500'>*</span>
                    </div>
                  }
                />
              </div>
              <div className='flex flex-col-reverse mob:flex-row mob:items-center gap-[8px] grow w-full'>
                <Button
                  color='white'
                  className='border-gray-100 text-[14px] lap:text-[20px] py-[10px] tab:py-[20px] grow'
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  {t('new_connection.cancel_btn')}
                </Button>
                <Button
                  loading={isLoadingSave}
                  color='white'
                  type='submit'
                  className='justify-center border-blue-200 bg-blue-100 hover:bg-blue-200 text-[14px] lap:text-[20px] py-[10px] tab:py-[20px] grow'
                >
                  {t('new_connection.confirm_btn')}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default PageNewConnection